import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@domain-group/fe-co-icon/lib/js/close';
import * as styles from './land-details-onboarding-mobile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LandDetailsOnboardingMobile = _ref => {
  var onTryOut = _ref.onTryOut,
    onClose = _ref.onClose;
  return ___EmotionJSX("div", {
    css: styles.mobileContainer
  }, ___EmotionJSX("button", {
    css: styles.mobileInnerButton,
    onClick: onTryOut,
    type: "button"
  }, "Need a better view? Tap to expand"), ___EmotionJSX("button", {
    css: styles.mobileCloseButton,
    onClick: onClose,
    type: "button",
    "aria-label": "Close"
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  })));
};
LandDetailsOnboardingMobile.propTypes = {
  onTryOut: PropTypes.func,
  onClose: PropTypes.func
};
LandDetailsOnboardingMobile.defaultProps = {
  onTryOut: () => {},
  onClose: () => {}
};
export default LandDetailsOnboardingMobile;